// Client-side mirror of internal/leave/leave.go's BusinessDays + Validate,
// used only to show live hints before submitting — the backend is the
// source of truth and re-validates on every request.
// ponytail: doesn't know the server's holiday calendar (internal/holidays),
// so this only excludes weekends; a holiday inside the range will show one
// business day too many until the backend responds. Upgrade path: expose
// GET /api/holidays if this drift becomes a real complaint.

import type { MessageKey } from '$lib/i18n/en';

function dateOnly(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function businessDays(start: string, end: string, halfDay: boolean): number {
  if (halfDay) return 0.5;
  const s = dateOnly(new Date(start));
  const e = dateOnly(new Date(end));
  if (s.getTime() === e.getTime()) return 1;
  let days = 0;
  for (let d = new Date(s); d.getTime() <= e.getTime(); d.setDate(d.getDate() + 1)) {
    const wd = d.getDay();
    if (wd !== 0 && wd !== 6) days++;
  }
  return days;
}

export function rangeHints(start: string, end: string, halfDay: boolean): MessageKey[] {
  if (!start || !end) return [];
  const hints: MessageKey[] = [];
  const s = dateOnly(new Date(start));
  const e = dateOnly(new Date(end));
  const today = dateOnly(new Date());
  if (e.getTime() < s.getTime()) hints.push('leave.hint.endBeforeStart');
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  if (s.getTime() < sevenDaysAgo.getTime()) hints.push('leave.hint.startTooPast');
  const oneYearOut = new Date(today);
  oneYearOut.setFullYear(oneYearOut.getFullYear() + 1);
  if (s.getTime() > oneYearOut.getTime()) hints.push('leave.hint.startTooFuture');
  if (!halfDay) {
    const spanDays = Math.round((e.getTime() - s.getTime()) / 86_400_000) + 1;
    if (spanDays > 30) hints.push('leave.hint.tooLong');
  }
  return hints;
}
